import { SpecialCalculationCost } from '@/types/special-calculation-cost';
import { Empty, TableProps } from 'antd';
import { SorterResult } from 'antd/es/table/interface';
import { AppTable } from '../atoms';
import { EMPTY_TEXT_FILTERED } from '@/constants';

interface SpecialCalculationCostTableProps {
  data: SpecialCalculationCost[];
  isLoading?: boolean;
  sortInfo?: {
    columnKey?: string;
    order?: 'ascend' | 'descend';
  };
  onTableChange?: (
    sorter: SorterResult<SpecialCalculationCost> | SorterResult<SpecialCalculationCost>[]
  ) => void;
  onDelete?: (id: number) => void;
}

const SpecialCalculationCostTable = ({
  data,
  isLoading,
  sortInfo,
  onTableChange,
}: SpecialCalculationCostTableProps) => {
  const columns: TableProps<SpecialCalculationCost>['columns'] = [
    {
      title: '保険者番号',
      dataIndex: 'insurer_number',
      key: 'insurer_number',
      sorter: true,
      sortOrder: sortInfo?.columnKey === 'insurer_number' ? sortInfo.order : undefined,
      width: '18%',
      render: (_, record) =>
        record.insurer ? (
          <p>
            {record.insurer.insurer_number}-{record.insurer.sub_number}
          </p>
        ) : (
          '-'
        ),
    },
    {
      title: '保険者名称',
      dataIndex: 'insurer_name',
      key: 'insurer_name',
      sorter: true,
      sortOrder: sortInfo?.columnKey === 'insurer_name' ? sortInfo.order : undefined,
      render: (_, record) => record.insurer?.insurer_name ?? '-',
    },
    {
      title: '特殊医療助成金',
      key: 'special_medical_aid',
      sorter: true,
      sortOrder: sortInfo?.columnKey === 'special_medical_aid' ? sortInfo.order : undefined,
      render: (_, record) => {
        const { calc_type, limit_amount, limit_num_month, limit_amount_month } = record;
        if (calc_type === 1) {
          return `1回${limit_amount ?? 0}円　月${limit_num_month ?? 0}回まで`;
        }
        if (calc_type === 2) {
          return `1ヵ月上限（限度額）${limit_amount_month ?? 0}円`;
        }
        if (calc_type === 3) {
          return `1回${limit_amount ?? 0}円　までで 1ヵ月上限（限度額）${limit_amount_month ?? 0}円`;
        }
        return '-';
      },
    },
    {
      title: '医療助成の負担割合で特殊医療助成の計算をする',
      key: 'is_adopted_lower_cost',
      sorter: true,
      sortOrder: sortInfo?.columnKey === 'is_adopted_lower_cost' ? sortInfo.order : undefined,
      render: (_, record) => (record.is_adopted_lower_cost ? '適用する' : '適用しない'),
    },
    {
      title: '請求区分',
      key: 'medix_claim_type',
      render: (_, record) => (
        <p className="whitespace-nowrap">{record.insurer?.medix_claim_type?.name ?? '-'}</p>
      ),
    },
  ];

  return (
    <AppTable
      columns={columns}
      dataSource={data}
      rowKey={record => record.id}
      onChange={(_pagination, _filters, sorter) =>
        onTableChange?.(
          sorter as SorterResult<SpecialCalculationCost> | SorterResult<SpecialCalculationCost>[]
        )
      }
      loading={isLoading}
      locale={{
        emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={EMPTY_TEXT_FILTERED} />,
      }}
    />
  );
};

export default SpecialCalculationCostTable;
